import useShelfAvailability from "./use-shelf-availability";

const GraphicWarehouseHooks = {
    useShelfAvailability
};

export {
    useShelfAvailability
};

export default GraphicWarehouseHooks;
